import { render, staticRenderFns } from "./content-sitegate-design-form.vue?vue&type=template&id=5b237def"
import script from "./content-sitegate-design-form.vue?vue&type=script&lang=js"
export * from "./content-sitegate-design-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports